import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { Spacer } from 'components/Utility'

type Props = {
  label: string
  value: string
  unit: string
}

const RevenueTotalCard: FC<Props> = React.memo((props) => {
  const { label, value, unit } = props

  return (
    <div className={styles.revenue__total}>
      <p className={styles.revenue__total__label}>{label}</p>
      <Spacer size={8} />
      <p>
        <span className={styles.revenue__total__value}>{value}</span>
        <span className={styles.revenue__total__unit}>{unit}</span>
      </p>
    </div>
  )
})

export default RevenueTotalCard
